<template>
    <VContainer>
        <BaseCard v-if="$store.state.org">
            <VCardTitle>
                Phone and Usage
            </VCardTitle>
            <VCardText v-if="!this.$store.state.customer">
                <p>You must have at least one <BaseBtn text to="/account/paymentmethods">payment method</BaseBtn> on file before you can purchase a phone number</p>
            </VCardText>
            <VCardText v-else>
                <VLayout row class="px-4">
                    <VFlex xs12 v-if="!$store.state.org.textappy.subAccount">
                        <h3>
                            You need to choose a phone number. It will be exclusively yours.
                        </h3>
                    </VFlex>
                    <VFlex xs12 v-else>
                        <v-list>
                            <v-list-item>
                                Phone Number: {{$store.state.org.textappy.subAccount.from}}
                            </v-list-item>
                            <v-list-item>
                                subAccountId: {{$store.state.org.textappy.subAccount.twilioSubSid}}
                            </v-list-item>
                            <v-list-item v-if="$store.state.org.textappy.stripe">
                                Credits/Month: {{$store.state.org.textappy.stripe.plan.metadata.credits}}
                            </v-list-item>
                            <v-list-item v-if="!addnumber && 1===2">
                                <BaseBtn @click="addnumber = true">Add Number</BaseBtn>
                            </v-list-item>
                        </v-list>
                    </VFlex>
                    <VFlex xs12 v-if="!($store.state.org.textappy.subAccount && ($store.state.dev)?$store.state.org.textappy.subAccount.fromTest:$store.state.org.textappy.subAccount.from)" > <!---addnumber-->
                        <v-text-field
                                label="Search Area Code"
                                dense
                                v-model="areacode"
                                clearable
                                outlined
                                type="number"
                                counter="3"
                                hint="enter area code"
                                :rules="[v => v && v.length===3]"
                                :append-outer-icon="icons.search"
                                @click:append-outer="searchByAreaCode()"
                                :prepend-icon="addnumber?$store.state.icons.close:''"
                                @click:prepend="addnumber = false"
                                :loading="loading"
                                :readonly="loading"
                        ></v-text-field>
                    </VFlex>
                </VLayout>
            </VCardText>
            <VCardActions>
                <BaseBtn  @click="$router.history.go(-1)">
                    <v-icon>{{icons.arrowleft}}</v-icon>
                    <span class="hidden-xs-only">Back</span>
                </BaseBtn>
                <v-spacer></v-spacer>
                <BaseBtn @click="recordsThisMonth()">Records</BaseBtn>
            </VCardActions>
        </BaseCard>
        <VDialog v-model="selectnumberdialog" scrollable>
            <BaseCard>
                <VCardTitle>Select Number</VCardTitle>
                <VCardText>
                    <v-list two-line dense>
                        <v-list-item v-for="a in areacodes" :key="a.phoneNumber" @click="confirmSelect(a)">
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{a.phoneNumber}}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    Capabilities: {{Object.keys(a.capabilities).join(' | ')}}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </VCardText>
                <VCardActions>
                    <BaseBtn @click="selectnumberdialog=false,areacode=''">Cancel</BaseBtn>
                </VCardActions>
            </BaseCard>
        </VDialog>
        <VDialog v-model="activenumber" v-if="activenumber">
            <BaseCard>
                <VCardTitle>Confirm Purchase</VCardTitle>
                <VCardText>
                    <p>
                        Confirm purchase of {{activenumber.phoneNumber}} - $2 per month?
                    </p>
                    <p>
                            <span v-for="(c,i) in activenumber.capabilities" :key="i">
                                {{i.toUpperCase()}}
                            </span>
                    </p>
                    <p class="subtitle-1">
                        Area: {{activenumber.region}} {{activenumber.isoCountry}}
                    </p>

                </VCardText>
                <VCardActions>
                    <BaseBtn @click="activenumber=false">Cancel</BaseBtn>
                    <v-spacer></v-spacer>
                    <BaseBtn @click="purchaseNumber()" :loading="loading">Yes</BaseBtn>
                </VCardActions>
            </BaseCard>
        </VDialog>
    </VContainer>
</template>

<script>
  import {
    mapState,
    mapActions
  }   from 'vuex'
  import BaseBtn from "../../components/BaseBtn";

  export default {
    components: {BaseBtn},
    name: "PhoneAndUsage",
    data() {
      return {
        areacode:'',
        loading:false,
        selectnumberdialog:false,
        areacodes:false,
        activenumber:false,
        addnumber:false,
        subplanid:'prod_FzTTSfqkwebMjP'
      }
    },
    computed:{
      ...mapState(['icons']),
      subscription(){
        let s = this.$store.state.products.filter(f=>{return f.id===this.subplanid})
        return s[0]
      },
      subscriptionplans(){
        let p = this.$store.state.plans.filter(f=>{return f.product===this.subplanid})
        return p
      },
    },
    mounted() {
    },
    methods: {
      ...mapActions(['post']),
      searchByAreaCode(){
        let em = this;
        em.loading=true;
        let args = {
          url:this.$store.state.url + 'api/twilio/searchphonebyareacode',
          method:"POST",
          data:{
            code: this.areacode,
          }
        }
        this.$store.dispatch('fetch',args).then(res=>{
          em.areacodes=res
          em.selectnumberdialog=true
          // if(res.code===400){
          //
          // } else {
          //
          // }
          em.loading=false
        }).catch(()=>{em.loading=false})
      },
      purchaseNumber(){
        let em = this;
        em.loading = true;
        let args = {
          url:this.$store.state.url + 'api/twilio/createphonenumberv2',
          method:"POST",
          data:{
            friendlyName: em.activenumber.friendlyName,
            phoneNumber: em.activenumber.phoneNumber,
            orgkey:this.$store.state.org.partkey,
            orgpartkey:this.$store.state.org.partkey
          }
        }

        this.$store.dispatch('fetch',args).then(()=>{
          em.loading=false;
          em.activenumber=false;
          em.selectnumberdialog = false;
          em.areacode=''
          em.$store.dispatch('getAppData')
        }).catch((e)=>{
          console.log(e)
          em.$store.commit('setSnackbar',{
            type: 'warning',
            msg: e,
            timeout:6000
          })
          em.loading=false;
          em.activenumber=false
        })
      },
      confirmSelect(s){
        this.activenumber = s;
        this.confirmselectdialog=true;
      },
      recordsThisMonth(){
        let em = this;
        let args = {
          url:this.$store.state.url + 'api/twilio/getrecordsthismonthv2',
          method:"POST",
          data:{}
        }
        this.$store.dispatch('fetch',args).then(res=>{
          console.log(res)
        }).catch(()=>{em.loading=false})
      },
    }
  }
</script>

<style scoped>

</style>